import { Box, Container, useBreakpointValue } from '@chakra-ui/react'
// import { useActiveSubscriptions, useStiggContext } from '@stigg/react-sdk'
import type { ReactNode } from 'react'
// import { useCallback, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { useColorModeValue } from '@app/components/ui/color-mode'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
// import Paywall from '@app/pages/settings/billing/components/paywall'
import Navbar from '@app/shared/layout/shells/components/navbar'
import Sidebar from '@app/shared/layout/shells/components/sidebar'
import GraphqlSubscriptionShell from '@app/shared/layout/shells/graphqlSubscriptionShell'
import MultiAccountBanner from '@app/shared/multiAccountBanner'

interface AppShellProps {
  children?: ReactNode
}

const AppShell = ({ children }: AppShellProps) => {
  const { user } = useStoreCurrentUser()
  const isDesktop = useBreakpointValue({ base: false, lg: true }, { ssr: false })
  // const { stigg } = useStiggContext()
  // const { activeSubscriptions } = useActiveSubscriptions()
  // const [customer, setCustomer] = useState(undefined)

  // const getCustomer = useCallback(async () => {
  //   await stigg
  //     .getCustomer()
  //     .then((res) => {
  //       setCustomer(res)
  //     })
  //     .catch(() => {})
  // }, [stigg])

  // useEffect(() => {
  //   getCustomer()
  // }, [getCustomer])

  let nav = <Navbar />

  if (isDesktop) {
    nav = <Sidebar />
  }

  const sidebarWidthDesktopWidth = '280px'
  const sidebarWidth = isDesktop ? sidebarWidthDesktopWidth : '100%'

  const mainContent = (
    <>
      <MultiAccountBanner />
      <Container>{children || <Outlet />}</Container>
    </>
  )

  // if (customer && activeSubscriptions && !activeSubscriptions.length) {
  //   mainContent = (
  //     <Stack pt={6} gap={6}>
  //       <Container>
  //         <Card.Root>
  //           <Card.Body textAlign="center">
  //             Your plan has expired, please upgrade to continue using DoubleLoop or{' '}
  //             <Text display="contents" as="span" color="blue.500" cursor="pointer" id="intercom-launcher">
  //               contact support
  //             </Text>
  //           </Card.Body>
  //         </Card.Root>
  //       </Container>
  //       <Paywall />
  //     </Stack>
  //   )
  // }

  return (
    <GraphqlSubscriptionShell strategyId={null}>
      <Box minH="100vh">
        {/* Navigation */}
        <Box
          pos={isDesktop ? 'fixed' : 'relative'}
          zIndex={1}
          top={0}
          left={0}
          bottom={0}
          overflow="hidden"
          w={sidebarWidth}
          shadow={useColorModeValue('xs', 'xs-dark')}
        >
          {user && nav}
        </Box>

        {/* Main Content */}
        <Box overflow="auto" minH="100vh" ml={isDesktop ? sidebarWidthDesktopWidth : 0} bg="bg.canvas" id="main">
          {mainContent}
          {/*  <MultiAccountBanner />*/}
          {/*  <Container>{children || <Outlet />}</Container>*/}
        </Box>
      </Box>
    </GraphqlSubscriptionShell>
  )
}

export default AppShell
